import { ReceiptText } from 'lucide-react';
import { Check } from 'lucide-react';
import { Tag } from 'lucide-react';
import {Cellule} from "../../../../types/cellule";
import React, {useState} from "react";
import {useDisclosure} from "@mantine/hooks";
import ajax from "../../../../services/AxiosInterceptor";
import {Modal, TextInput} from "@mantine/core";
import {LoadingButton} from "../../../../components/loading_button/loading_button";
import {Codes_promo} from "../../../../types/codes_promo";
import {afficherDate, DateTZ} from "../../../../services/GestionDates";
import {notifications} from "@mantine/notifications";
import env_config from "../../../../env_config";

export function Modale_appliquer_code_promo({
                                                cellule,
                                                triggerRefresh
                                            }: { cellule: Cellule, triggerRefresh: () => void }) {
    const [opened, handlers] = useDisclosure(false);
    const [save_btn_loading, set_save_btn_loading] = useState("");
    const [code_promo_input, set_code_promo_input] = useState("");

    const [erreur, setErreur] = useState("");

    const [code_promo, setCode_promo] = useState<Codes_promo|null>(null);

    const [notice_remise_deja_presente, setNotice_remise_deja_presente] = useState<{promo_deja_active_pourcentage:number, promo_deja_active_debut:DateTZ, promo_deja_active_fin:DateTZ}|null>(null);

    // if (forcer) handlers.open();

    function handleVerifier() {
        setErreur("")
        set_save_btn_loading("verif");
        ajax.get("/cellules/" + cellule.id + "/codes_promo/" + code_promo_input).then(response => {
            setCode_promo(response.data.code_promo)

            let promo_deja_active_pourcentage = response.data.promo_deja_active_pourcentage;
            let promo_deja_active_debut = response.data.promo_deja_active_debut;
            let promo_deja_active_fin = response.data.promo_deja_active_fin;

            if (promo_deja_active_pourcentage > 0
                && new DateTZ(promo_deja_active_debut).getTime() <= new DateTZ().getTime()
                && new DateTZ(promo_deja_active_fin).getTime() >= new DateTZ().getTime()
                && response.data.code_promo?.remise > 0
            ){
                setNotice_remise_deja_presente({
                    promo_deja_active_debut: promo_deja_active_debut,
                    promo_deja_active_fin: promo_deja_active_fin,
                    promo_deja_active_pourcentage: promo_deja_active_pourcentage,
                })
            }

            set_save_btn_loading("");
        }).catch(error => {
            setErreur(error.response?.data.erreur ? error.response.data.erreur : 'Une erreur est survenue.')
            set_save_btn_loading('');
            setCode_promo(null)
        })

    }

    function handleEnregistrer() {
        setErreur("")
        set_save_btn_loading("save");
        ajax.post("/cellules/" + cellule.id + "/codes_promo/" + code_promo_input).then(response => {
            triggerRefresh();
            handlers.close();
            set_save_btn_loading('');
            notifications.show({
                withCloseButton: true,
                autoClose: env_config.notifications_duree_affichage,
                title: "Code promotionnel appliqué !",
                message: "" ,
                color: 'green',
                loading: false,
                closeButtonProps: { 'aria-label': 'Hide notification' }
            });
        }).catch(error => {
            setErreur(error.response?.data.erreur ? error.response.data.erreur : 'Une erreur est survenue.')
            set_save_btn_loading('');
            setCode_promo(null)
        })

    }

    function calc_date_fin(duree:number)
    {
        let date = new DateTZ();
        date.setDate(date.getDate() + duree)
        return afficherDate(date);
    }

    return (
        <>
            <button className={"sec"} onClick={handlers.open}><ReceiptText/> Appliquer un code promotionnel</button>
            <Modal opened={opened} onClose={handlers.close} title="Appliquer un code promotionnel">
                <div className={"form"}>
                    <TextInput type="text"
                               value={code_promo_input}
                               onChange={event => set_code_promo_input(event.target.value)}
                               placeholder={"Code promo"}/>
                    <LoadingButton is_loading={save_btn_loading==="verif"} disabled={code_promo_input === ""}
                                   onClick={handleVerifier}>Vérifier la disponibilité</LoadingButton>

                    {erreur !== "" && <p className={"notice red"}>{erreur}</p>}

                    {code_promo && (
                        <>
                            <p>Code promotionnel disponible !</p>
                            {code_promo.statut_cellule && (
                                <>
                                    <p>L'abonnement suivant sera appliqué à votre cellule, sans frais : {code_promo.statut_cellule.nom}</p>
                                    <p>L'abonnement sera appliqué de aujourd'hui jusqu'au {calc_date_fin(code_promo.duree_statut)}</p>
                                </>
                            )}
                            {code_promo.remise === 1 && (
                                <>
                                    <p>Votre abonnement actuel va bénéficier d'une remise de {code_promo.remise}% pour le mois à venir.</p>
                                </>
                            )}
                            {code_promo.remise > 1 && (
                                <>
                                    <p>Votre abonnement actuel va bénéficier d'une remise de {code_promo.remise}% pour les {Math.round( code_promo.duree_statut / 31)} mois à venir.</p>
                                </>
                            )}


                            {(code_promo.usage_unique || code_promo.un_par_orga) &&
                                <p>Ce code promotionnel est à usage unique.</p>
                            }

                            {(code_promo.un_par_cellule) &&
                                <p>Ce code promotionnel ne pourra pas être réutilisé sur cette cellule.</p>
                            }

                            {(code_promo.nbe_fois_par_enregistreur) &&
                                <>
                                    <p>Ce code promotionnel ne peut être utilisé que {code_promo.nbe_fois_par_enregistreur} fois sur un même enregistreur.</p>

                                    {(code_promo.date_fin_definie_par_utilisation_precedente_sur_enregistreur) &&
                                        <p>De plus, la date de fin de la promotion est fixé à la 1ère activation.</p>
                                    }
                                </>
                            }

                            {notice_remise_deja_presente && (
                                <p className={"notice orange"}>
                                    Votre cellule a actuellement une remise active de {notice_remise_deja_presente.promo_deja_active_pourcentage}%,
                                    valable jusqu'au {afficherDate(notice_remise_deja_presente.promo_deja_active_fin)}.
                                    <br/>
                                    Appliquer une nouvelle remise remplacera la remise existante.
                                </p>
                            )}

                            <LoadingButton is_loading={save_btn_loading==='save'}
                                           onClick={handleEnregistrer}><Check /> Appliquer ce code</LoadingButton>
                        </>
                    )}
                </div>

            </Modal>
        </>

    )
}